.container {
  & > p {
    font-weight: 400;
    font-size: 1.4rem;
    color: var(--color-grayscale-manatee);
    margin-bottom: 2.4rem;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  gap: 0.8rem;
}
